import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";

const Button = styled.button`
  height: 40px;
  padding-left: 16px;
  padding-right: 16px;
  border: 0;
  -webkit-border-radius: 3px;
  border-radius: 1px;
  text-transform: none;
  letter-spacing: 0.25px;
  min-width: 60px;
  :focus {
    outline: none;
  }
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: baseline;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  background-color: ${props =>
    props.secondary
      ? props.theme.color4
      : props.inverted
      ? props.theme.color3
      : props.theme.color5};
  color: ${props =>
    props.secondary
      ? props.theme.color5
      : props.inverted
      ? props.theme.color5
      : props.theme.color1};
  &:hover,
  &:focus {
    opacity: 0.6;
  }
  min-width: ${props => props.minWidth || "120px"};
`;

const EditButton = styled.button`
  height: 48px;
  border: 1px solid ${props => props.theme.color2};
  font-size: 14px;
  color: ${props => props.theme.color2};
  font-weight: 600;
  padding-right: 30px;
  padding-left: 30px;
  min-width: 60px;
  cursor: pointer;
  :focus {
    outline: none;
  }
`;

const DeleteButton = styled.button`
  height: 48px;
  font-size: 14px;
  color: ${props => props.theme.color2};
  font-weight: 700;
  padding-right: 20px;
  padding-left: 20px;
  min-width: 60px;
  cursor: pointer;
  background-color: transparent;
  :focus {
    outline: none;
  }
`;

export const Edit = withTheme(({ theme, onClick }) => {
  return (
    <EditButton onClick={onClick}>
      <FontAwesomeIcon icon={["fas", "pen"]} size="1x" color={theme.color2} />{" "}
      Edit
    </EditButton>
  );
});

export const Delete = withTheme(({ theme, onClick }) => {
  return (
    <DeleteButton onClick={onClick}>
      <FontAwesomeIcon
        icon={["fas", "trash-alt"]}
        size="1x"
        color={theme.color2}
      />{" "}
      Delete
    </DeleteButton>
  );
});

export default Button;
